import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

function gradeClass(grade) {
  if (grade == null) return '';
  return `pd-benchmark__grade--${grade[0].toLowerCase()}`;
}

export default class ProxyviewsBenchmarksCompareController extends Controller {
  queryParams = ['providers'];
  @tracked providers = '';

  get hasData() {
    return this.model && this.model.summary && this.model.summary.length > 0;
  }

  gradeClassFor(grade) {
    return gradeClass(grade);
  }

  @action
  goBack() {
    this.transitionToRoute('proxyviews-benchmarks');
  }
}
